import {GETEMAILTEMPLATES, GETEMAILTEMPLATEONE} from '../actions/constant';

const INITIAL_STATE = {
    email_temp: [],
    email_one: {}
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type){
        case GETEMAILTEMPLATES:
            return {...state, email_temp:action.payload.data}; 
        case GETEMAILTEMPLATEONE:
            return {...state, email_one:action.payload.data};
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_email_templates.js